import {
  CAS_TRANSIT_PATH,
  shouldBypassLoginPageForCas,
} from "@/utils/casSso";

/**
 * CAS 流量在进入登录页组件之前改走 /cas，
 * 避免 SSR/首屏先画出本地登录表单再盖遮罩。
 * 门控见 shouldBypassLoginPageForCas：仅 enableCasLogin / ticket / 中转标记，不按主机名。
 */
export default defineNuxtRouteMiddleware((to) => {
  let host = "";
  if (process.server) {
    const headers = useRequestHeaders(["host"]);
    host = headers.host || "";
  } else if (typeof window !== "undefined") {
    host = window.location.host || "";
  }

  if (!shouldBypassLoginPageForCas(to, host)) {
    return;
  }

  const query = {};
  if (to.query.ticket) {
    query.ticket = to.query.ticket;
  }
  if (to.query.redirect) {
    query.redirect = to.query.redirect;
  }

  return navigateTo(
    {
      path: CAS_TRANSIT_PATH,
      query,
    },
    { replace: true }
  );
});
